import { createTheme } from "@mantine/core";

export const theme = createTheme({
  primaryColor: "blue",
  fontFamily: '"Inter Variable", system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  defaultRadius: "md",
  components: {
    Button: {
      defaultProps: {
        variant: "filled",
      },
    },
  },
});
